import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import PubItem from "./PubItem";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export default function RobListing() {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query RobListQuery {
      allWpPub(
        filter: { PubData: { brand: { eq: "Managed" } } }
        sort: { fields: title, order: ASC }
      ) {
        nodes {
          PubData {
            featuredImage
            localFile {
              id
              publicURL
              childImageSharp {
                gatsbyImageData(
                  width: 920
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { fit: COVER, cropFocus: CENTER }
                )
              }
            }
            name
            displayLocation
            telephone
            hasOwnWebsite
            url
            facilityAccommodation
          }
          id
          slug
        }
      }
    }
  `);

  return (
    <Grid container spacing={2} direction="row">
      {data.allWpPub.nodes.map((pub) => {
        return <PubItem classes={classes} pub={pub.PubData} />;
      })}
    </Grid>
  );
}
